// extracted by mini-css-extract-plugin
export default {"bounce":"T_fk","loading":"T_fl","logo-mark-bounce-right":"T_fm","logo-mark-bounce-left":"T_fn"};